moduleViewApp.controller('setIndexCtrl', ['$scope', '$route', '$routeParams', 'ExternalLinkHelper', 'myPartnersService', 'V3PartnersResource', 'LibraryModel', 'MySetsResource', 'MySeriesResource', 'EmailsResource', 'PartnersResource', 'UserManager', 'V2GroupContextService', 'SiteNavigationService', '$window', 'V3ModelHelper', 'NewSetService', ($scope, $route, $routeParams, ExternalLinkHelper, myPartnersService, V3PartnersResource, LibraryModel, MySetsResource, MySeriesResource, EmailsResource, PartnersResource, UserManager, V2GroupContextService, SiteNavigationService, $window, V3ModelHelper, NewSetService) ->
  window.debug = window.debug || {}
  window.debug["setIndexScope"] = $scope

  bootstrapData = angular.element("#module--container").data()

  $scope.$on "pagination:Pagechanged", (event, page, module_type) ->
    if module_type == 'sets'
      $scope.set_offset = (page - 1) * $scope.limit
      $scope.fetchMySets()
    else
      $scope.series_offset = (page - 1) * $scope.limit
      $scope.fetchMySeries()

  _.assignIn $scope,
    uiState: {}
    limit: 12
    routes: Packs.iKnowRoutes
    defaultGoalImage: bootstrapData.defaultGoalImage
    currentTab: $routeParams.tab || 'sets'
    V2GroupContextService: V2GroupContextService
    displayChangeCard: true
    ExternalLinkHelper: ExternalLinkHelper

    hideChangeCard: ->
      $scope.displayChangeCard = false

    initializePartner: (partner) ->
      $scope.partner = partner

      if $scope.partner?.relationships?.image
        $scope.iconImage = $scope.partner?.relationships?.image

      $scope.setService = LibraryModel([], $scope.partner, 'sets')
      $scope.seriesService = LibraryModel([], $scope.partner, 'series')

      if $scope.partner?.attributes['partner-settings']?['scorm-set-creation-enabled'] || UserManager.currentUser.meta['is-admin']
        $scope.uiState.scormCreationAllowed = true

    initialize: ->
      UserManager.loadUser().then (user) ->
        if !user.id
          $window.location.href = Packs.iKnowRoutes.v3_signin_path()
        else if $routeParams.parentId
          V3PartnersResource.get(id: $routeParams.parentId, (success) ->
            $scope.initializePartner V3ModelHelper.parse(success)
          ).$promise
        else
          myPartnersService.initialize().then () ->
            $scope.initializePartner myPartnersService.currentProductPartner

    tileOffset: ->
      angular.element("#site-navigation").width() || 0

    fetchFilteredSets: ->
      $scope.set_offset = 0
      $scope.fetchMySets()

    fetchFilteredSeries: ->
      $scope.series_offset = 0
      $scope.fetchMySeries()

    fetchMySets: ->
      $scope.setService.libraryLoaded = false

      params =
        limit: $scope.limit
        offset: $scope.set_offset
        public: $scope.setService.privacyPublic
        private: $scope.setService.privacyPrivate
        collaborator_only: $scope.setService.filterCollaboration
        include_remix: $scope.setService.includeClones
        search: $scope.setService.searchText
        order: $scope.setService.sortOrder.value

      if $scope.partner
        resource = PartnersResource.sets
        _.assignIn(params,
          partner_id: $scope.partner.id
          course_only: $scope.setService.privacyCourse
        )
        if $scope.setService.filterCreator
          params.creator_id = UserManager.currentUser.id
        if $scope.setService.filterEditor
          params.editor_id = UserManager.currentUser.id
      else
        resource = MySetsResource.query

      resource params
      , (success) ->
        $scope.setResponse(success.response)
      , (error) ->
        console.error error

    fetchMySeries: ->
      $scope.seriesService.libraryLoaded = false
      params =
        limit: $scope.limit
        offset: $scope.series_offset
        public: $scope.seriesService.privacyPublic
        private: $scope.seriesService.privacyPrivate
        search: $scope.seriesService.searchText
        order: $scope.seriesService.sortOrder.value

      if $scope.partner
        resource = PartnersResource.series
        _.assignIn(params,
          partner_id: $scope.partner.id
          course_only: $scope.seriesService.privacyCourse
        )
        if $scope.seriesService.filterCreator
          params.creator_id = UserManager.currentUser.id
        if $scope.seriesService.filterEditor
          params.editor_id = UserManager.currentUser.id
      else
        resource = MySeriesResource.query

      resource params
      , (success) ->
        $scope.seriesResponse(success.response)
      , (error) ->
        console.error error

    setResponse: (response) ->
      $scope.setService.updateModules(response["sets"])
      $scope.sets_count = response["sets_count"]
      $scope.iconImage ||= _.compact(_.map(debug.setIndexScope.setService.modules, "image"))[0]

    seriesResponse: (response) ->
      $scope.seriesService.updateModules(response["series"])
      $scope.series_count = response["series_count"]

    modulePath: (module) ->
      if SiteNavigationService.isCreate()
        if module.module_type == "set"
          if module.scorm_package_id
            Packs.iKnowRoutes.edit_details_v2_create_set_path(module.id)
          else if module.learn_version == 4
            Packs.iKnowRoutes.edit_v4_edit_set_path(module.id)
          else
            Packs.iKnowRoutes.edit_v3_create_set_path(module.id)
        else
          Packs.iKnowRoutes.v2_create_series_path(module.id)
      else
        if module.module_type == "set"
          Packs.iKnowRoutes.v3_learn_set_path(module.id)
        else
          Packs.iKnowRoutes.v3_learn_series_path(module.id)

    createGoal: (goalType) ->
      if goalType == 'set'
        NewSetService.createNewSet('set')
      else if goalType == 'assessment'
        NewSetService.createNewSet('assessment')
      else if goalType == 'survey'
        NewSetService.createNewSet('survey')
      else
        throw 'Could not create goal for goalType: ' + goalType

    moduleTilePath: (module) ->
      if SiteNavigationService.isCreate()
        if module.module_type == "set"
          Packs.iKnowRoutes.v2_create_set_path(module.id)
        else
          Packs.iKnowRoutes.v2_create_series_path(module.id)
      else
        if module.module_type == "set"
          Packs.iKnowRoutes.v3_learn_set_path(module.id)
        else
          Packs.iKnowRoutes.v3_learn_series_path(module.id)

    precomputeData: ->
      for module in $scope.setService.modules
        _.assignIn module, {
          modulePath:  $scope.modulePath(module)
          inLibrary: module.settings && module.settings.library_subscription_state < 1
          moduleTilePath: $scope.moduleTilePath(module)
          isAssessment: module.goal_type == 'assessment'
        }

    precomputeSeriesData: ->
      for module in $scope.seriesService.modules
        _.assignIn module, {
          modulePath:  $scope.modulePath(module)
          inLibrary: module.settings && module.settings.library_subscription_state < 1
        }

  $scope.$on "moduleDropDown:delete", (event, removedId, moduleType) ->
    if moduleType == 'series'
      $scope.seriesService.modules = _.reject $scope.seriesService.modules, (s) ->
        s.id == removedId
    else
      $scope.setService.modules = _.reject $scope.setService.modules, (set) ->
        set.id == removedId

  $scope.$watch("setService.modules", ->
    if $scope.setService
      $scope.precomputeData()
  )

  $scope.$watch("seriesService.modules", ->
    if $scope.seriesService
      $scope.precomputeSeriesData()
  )

  $scope.initialize().then () ->
    $scope.isAdmin = UserManager.isAdmin()
    $scope.fetchMySets()
    $scope.fetchMySeries()
])
